import { Toaster } from 'sonner';

/**
 * Sonner toaster — estilo brand (creme + navy text + sage accent).
 * `richColors` ativa as variantes (success/error/info) com paleta dele;
 * sobrescrevemos via CSS vars no globals.css se quisermos custom.
 */
export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        className: 'font-sans',
        style: {
          fontFamily: 'var(--font-sans)',
        },
      }}
    />
  );
}
